<template>
  <div class="autocomplete">
    <div class="autocomplete-holder" v-click-outside="closeAutocomplete">
        <input
            id="autocomplete"
            class="autocomplete-field"
            type="text"
            :class="{'focused': searchValue.length > 0 && inputFocused}"
            placeholder="Find your favorite shop"
            v-model="searchValue"
            @input="$emit('searchstore', $event.target.value)"
            @focus="inputFocused = true"
            autocomplete="off"
        >
      <div class="autocomplete-list" v-show="searchValue.length > 0 && inputFocused" ref="promoCode">
        <div class="autocomplete-list-item" v-for="item in relevantList" :key="item.link" @click="openStoreFromSearch(item)">
          <div class="list-item-image">
            <img :src="item.computed_logo || imgPlaceholder()" :alt="item.name" @error="imgPlaceholder">
          </div>
          <div class="list-item-body">
            <div class="list-item-name">
              {{item.name}}
            </div>
            <div class="list-item-discount">
             <span class="text-blue">{{item.cashback_max_description ? item.cashback_max_description : ''}}</span>
              and
              <span class="text-green">{{item.offers_count ? item.offers_count + ' deals' : ''}}</span>
            </div>
          </div>
          <div class="list-item-arrow">
            <img src="../assets/img/arrow-r.svg" alt="arrow">
          </div>
        </div>
        <div class="autocomplete-list-item-empty" v-if="relevantList.length === 0">
          <div class="text-center">
            <img src="../assets/img/bi_shop.png" alt="shop">
          </div>
          <div class="autocomplete-list-item-empty-body">
            No shops found for "<b>{{searchValue}}</b>"
          </div>
          <div class="autocomplete-list-item-empty-footer no-result">
            <a class="search-link" :href="'https://www.google.com/search?q=' + searchValue" target="_blank">
              search the web
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {reportEvent} from "@/utils";
import vClickOutside from 'click-outside-vue3'
export default {
  name: 'Search',
  props: ['relevantList'],
  data() {
    return {
      searchValue: '',
      inputFocused: false,
    }
  },
  methods: {
    openStoreFromSearch (item) {
      this.$emit('openstore', item)
      reportEvent('search', {
        query: this.searchValue,
        action: 'store',
        key: item.host
      })

      reportEvent('store', {
        action: 'view',
        key: item.host,
        ref: 'search'
      })
    },
    closeAutocomplete () {
      this.inputFocused = false
    },
    imgPlaceholder() {
      return require('../assets/img/cashback-icon.svg');
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>
<style lang="scss">
.autocomplete-holder {
  position: relative;
}

.autocomplete-list {
  position: absolute;
  top: 100%;
  width: 100%;
  font-size: 14px;
  z-index: 2;
  background: #FFFFFF;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  max-height: 400px;
  overflow: auto;
}

.autocomplete-list-item {
  padding: 12px;
  border-top: 1px solid rgba(81, 78, 104, 0.1);
  display: flex;
  align-items: center;
  transition: all 0.3s;

  &:hover {
    cursor: pointer;
    background-color: #f6f6f7;
  }
}

.list-item-body {
  flex: 1;
}

.list-item-image {
  width: 42px;
  height: 42px;
  background: #FFFFFF;
  border: 1px solid #EEEEF0;
  border-radius: 4px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: none;
  margin-right: 8px;
}

.list-item-arrow {
  margin-left: 4px;
  flex: none;
}

.list-item-name {
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 4px;
  font-weight: bold;
}

.list-item-discount {
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  color: #9492a1;
}

.autocomplete-list-item-empty {
  display: block;
  text-align: center;
  font-size: 12px;
  border-top: 1px solid rgba(81, 78, 104, 0.1);
  padding-top: 14px;
}

.autocomplete-list-item-empty-body {
  margin: 12px 0;
}

.autocomplete-list-item-empty-footer {
  padding: 12px;
  border-top: 1px solid rgba(81, 78, 104, 0.1);
  text-transform: uppercase;
}

</style>
